import './spinner.css';

const Loader = () => {
  return (
    <div className='flex flex-col justify-between w-full h-full '>
      <div className='flex flex-col justify-between w-full h-full '>
      <div className="preloader w-full h-full -mt-4">
          <div className="crack crack1 bg-[#ffffff]"></div>
          <div className="crack crack2 bg-[#278afa]"></div>
          <div className="crack crack3 bg-[#00fd2a]"></div>
          {/* <div className="crack crack4"></div>
          <div className="crack crack5"></div> */}
        </div>
        <div className="loader w-[50%] mx-auto">
          {/* <div className="loader__circle"></div> */}
          <div className="loader__circle"></div>
          <div className="loader__circle"></div>
          <div className="loader__circle"></div>
          {/* <div className="loader__circle"></div> */}
        </div>
    </div>
    </div>
    
  );
}

export default Loader;
